import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'doll-sister:favorites';

function readFavorites(): string[] {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((item): item is string => typeof item === 'string');
  } catch {
    return [];
  }
}

export function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    setFavorites(readFavorites());
  }, []);

  const isFavorite = useCallback((id: string) => favorites.includes(id), [favorites]);

  const toggleFavorite = useCallback((id: string) => {
    const next = readFavorites();
    const exists = next.includes(id);
    const updated = exists ? next.filter((item) => item !== id) : [...next, id];
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    } catch {
      // 存储不可用时仅更新内存状态
    }
    setFavorites(updated);
    return !exists;
  }, []);

  return { favorites, isFavorite, toggleFavorite };
}